module.exports = __webpack_public_path__ + "img/discovery.b528ec01.jpg";